import { assertEvent, assign } from 'xstate';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Sets a custom name (e.g. "John's salad") based on the provided data.
 */
export const setCustomName: CustomizationMachineAction = assign((args) => {
  const { event } = args;

  assertEvent(event, 'customization.set-custom-name');

  return {
    customName: event.customName.trim(),
  };
});
